export default {
  common: {
    loading: 'ກຳລັງໂຫຼດ',
    confirm: 'ຢືນຢັນ',
    cancel: 'ຍົກເລີກ',
    save: 'ບັນທຶກ',
    back: 'ກັບຄືນ',
    copy: 'ຄັດລອກ',
    delete: 'ລົບ',
    copySuccess: 'ຄັດລອກສຳເລັດ',
    editSuccess: 'ແກ້ໄຂສຳເລັດ',
    deleteSuccess: 'ລົບສຳເລັດ',
    modifySuccess: 'ອັບເດດສຳເລັດ',
    cannotBeEmpty: 'ບໍ່ຄວນປ່ອນໃຫ້ວ່າງ',
    noContent: 'ບໍ່ມີເນື້ອໃນ',
    noData: 'ບໍ່ມີຂໍ້ມູນທີ່ກ່ຽວຂ້ອງ',
    noMoreData: 'ບໍ່ມີຂໍ້ມູນເພີ່ມເຕີມ',
    iKnow: 'ຂ້ອຍເຂົ້າໃຈແລ້ວ',
    selectService: 'ເລືອກຜູ້ໃຫ້ບໍລິການ',
    sendSuccess: 'ສົ່ງສຳເລັດ',
  },
  billHome: {
    recharge: 'ບໍລິການເພີ່ມເງິນ/ຊຳລະ',
    coupon: 'ຄູປອງ',
    rechargeNow: 'ເພີ່ມເງິນຕອນນີ້',
    cost: 'ຄ່າໂທ',
    flow: 'ອິນເຕີເນັດ',
    rechargeNotice: 'ຂໍ້ມູນກ່ອນເພີ່ມເງິນ',
    rechargeCost: 'ເພີ່ມເງິນຄ່າໂທ',
    rechargeFlow: 'ເພີ່ມເງິນອິນເຕີເນັດ',
    rechargeAmount: 'ຈຳນວນເງິນ',
    rechargePackage: 'ແພັກເກດເພີ່ມເງິນ',
    discount: 'ສ່ວນຫຼຸດແລ້ວ',
    confirmTxt: 'ກວດສອບຖືກຕ້ອງ',
    confirmTxt1: 'ເຂົ້າໃຈແລ້ວ',
    actualPayment: 'ຈຳນວນຈ່າຍຈິງ',
    selectCoupon: 'ເລືອກຄູປອງ',
    useRule: 'ເງື່ອນໄຂການໃຊ້',
    availableCoupon: 'ຄູປອງທີ່ໃຊ້ໄດ້',
    unavailableCoupon: 'ຄູປອງໃຊ້ບໍ່ໄດ້',
    noAvailableCoupon: 'ບໍ່ມີຄູປອງທີ່ໃຊ້ໄດ້',
    selectPhone: 'ເລືອກເບີໂທລະສັບ',
    pleaseInputPhone: 'ກະລຸນາປ້ອນເບີໂທ',
    couponCount: 'ຄູປອງທີ່ໃຊ້ໄດ້',
    pleaseInputCorrectPhone: 'ກະລຸນາໃສ່ເບີໂທລະສັບທີ່ຖືກຕ້ອງ',
    pleaseSelectPackage: 'ກະລຸນາເລືອກແພັກເກດເຕີມເງິນ',
  },
  accountManage: {
    title: 'ຈັດການບັນຊີ',
    edit: 'ແກ້ໄຂ',
    deleteConfirm: 'ຢືນຢັນການລົບ',
  },
  rechargeDetail: {
    title: 'ລາຍລະອຽດການຊຳລະ',
    continuePay: 'ສືບຕໍ່ການຊຳລະ',
  },
  feesExpense: {
    title: 'ປະຫວັດການຊຳລະ',
    recharge: 'ເບີໂທ',
    electricity: 'ຄ່າໄຟຟ້າ',
    internet: 'ອິນເຕີເນັດ',
    water: 'ຄ່ານ້ຳ',
    photo: 'ຖ່າຍຮູບ',
    complete: 'ສຳເລັດ',
    manage: 'ຈັດການ',
    allSelect: 'ເລືອກທັງໝົດ',
    selected: 'ເລືອກແລ້ວ',
    deleteConfirm: '',
    deleteRecord: 'ລົບການຊຳລະນີ້ບໍ?',
    noDataAction: 'ບໍ່ມີຂໍ້ມູນໃຫ້ຈັດການ',
    pleaseSelect: 'ກະລຸນາເລືອກລາຍການທີ່ຈະລົບ',
    feesNotice: 'ຂໍ້ມູນກ່ອນຊຳລະ',
  },
  formCom: {
    upload: 'ຄລິກເພື່ອອັບໂຫລດ',
    saveAccount: 'ບັນທຶກ ຫຼື ອັບເດດບັນຊີ',
    createOrder: 'ສ້າງຄຳສັ່ງຊື້',
    rechargeIng: 'ກຳລັງເພີ່ມເງິນ',
    rechargeNow: 'ເພີ່ມເງິນຕອນນີ້',
    serviceProvider: 'ຜູ້ໃຫ້ບໍລິການ',
    billImage: 'ຮູບບິນ',
    returnSelect: 'ກັບໄປເລືອກໃໝ່',
    electricity: 'ຄ່າໄຟຟ້າ',
    internet: 'ຄ່າອິນເຕີເນັດ',
    water: 'ຄ່ານ້ຳ',
    photo: 'ຊຳລະຜ່ານຮູບພາບ',
    life: 'ຄ່າໃຊ້ຈ່າຍປະຈຳວັນ',
    uploadFail: 'ອັບໂຫລດບໍ່ສຳເລັດ ກະລຸນາລອງໃໝ່',
    pleaseFill: 'ກະລຸນາກອກຂໍ້ມູນໃຫ້ຄົບ',
    submitSuccess: 'ສົ່ງສຳເລັດ ກະລຸນາລໍຖ້າການຈ່າຍເງິນ',
  },
  langPop: {
    selectLang: 'ເລືອກພາສາ',
  },
  loginPop: {
    loginOrRegister: 'ກະລຸນາເຂົ້າລະບົບ ຫຼື ລົງທະບຽນ Kuaizi',
    confirmLogout: 'ທ່ານແນ່ໃຈບໍວ່າຈະອອກຈາກລະບົບ?',
    toLogin: 'ເຂົ້າລະບົບ',
    logoutSuccess: 'ອອກຈາກລະບົບສຳເລັດ',
  },
  newMe: {
    myOrder: 'ຄຳສັ່ງຊື້ຂອງຂ້ອຍ',
    coupon: 'ຄູປອງ',
    accountManage: 'ຈັດການບັນຊີ',
    orderCount: 'ຄຳສັ່ງຊື້ກຳລັງດຳເນີນ',
    couponCount: 'ໃບ',
    account: 'ບັນຊີ',
    logout: 'ອອກຈາກລະບົບ',
  },
  coupons: {
    all: 'ທັງໝົດ',
    coupon: 'ຄູປອງ',
    historyCoupon: 'ຄູປອງທີ່ໃຊ້ແລ້ວ/ໝົດອາຍຸ',
    use: 'ໃຊ້',
    validityPeriod: 'ວັນໝົດອາຍຸ',
    useRule: 'ເງື່ອນໄຂ',
    used: 'ໃຊ້ແລ້ວ',
    expired: 'ໝົດອາຍຸ',
  },
  accountSeting: {
    title: 'ການຕັ້ງຄ່າ',
    personalInfo: 'ຂໍ້ມູນສ່ວນຕົວ',
    modifyPayPassword: 'ປ່ຽນລະຫັດການຈ່າຍເງິນ',
    modifyLoginPassword: 'ປ່ຽນລະຫັດເຂົ້າລະບົບ',
    phone: 'ເບີໂທ',
    code: 'ລະຫັດຢືນຢັນ',
    loginPassword: 'ລະຫັດເຂົ້າລະບົບ',
    confirmModify: 'ຢືນຢັນການປ່ຽນແປງ',
    noCode: 'ບໍ່ໄດ້ຮັບລະຫັດ?',
    passwordPlaceholder: '8–16 ຕົວອັກສອນ ລວມຕົວເລກ',
    inputCorrectPhone: 'ໃສ່ເບີໂທໃຫ້ຖືກຕ້ອງ',
    afterGetCode: 'ຮັບຄືນໄດ້ຫຼັງ',
    getCode: 'ຮັບລະຫັດ',
    input6DigitPassword: 'ປ້ອນລະຫັດ 6 ໂຕເລກ',
    twoInputPasswordNotConsistent: 'ລະຫັດບໍ່ກົງກັນ',
    placeholderCode: 'ປ້ອນລະຫັດຢືນຢັນ',
    confirmPassword: 'ຢືນຢັນລະຫັດ',
    password: 'ລະຫັດຜ່ານ',
    submit: 'ສົ່ງ',
    avatar: 'ຮູບໂປຣໄຟລ໌',
    userName: 'ຊື່ຜູ້ໃຊ້',
    nickName: 'ຊື່ຫຼິ້ນ',
    modifyPhone: 'ປ່ຽນເບີໂທ',
    nickNamePlaceholder: 'ສະແດງຄວາມເປັນຕົວຂອງທ່ານ',
    sex: 'ເພດ',
    male: 'ຊາຍ',
    female: 'ຍິງ',
    email: 'ອີເມວ',
    emailPlaceholder: 'ໃສ່ອີເມວເພື່ອກູ້ລະຫັດ',
    pleaseCompletePersonalData: 'ກະລຸນາກອກຂໍ້ມູນສ່ວນຕົວໃຫ້ຄົບເພື່ອໃຊ້ງານຟັງຊັນເພີ່ມເຕີມ',
    bindNewPhone: 'ເຊື່ອມເບີໃໝ່',
    oldPhone: 'ເບີເກົ່າ',
    completeVerification: 'ຢືນຢັນໃຫ້ແລ້ວ',
    changePayPasswordTitle: 'ປ່ຽນລະຫັດຈ່າຍເງິນ',
    changePasswordTitle: 'ປ່ຽນລະຫັດຜ່ານ',
    oldPhoneTitle: 'ຢືນຢັນເບີເກົ່າ',
    editInfoTitle: 'ແກ້ໄຂຂໍ້ມູນ',
    areaCode: 'ລະຫັດເຂດ',
  },
}
